import { IReactionDisposer, reaction } from 'mobx';
import { Query } from '@project/store/Query';
import { debounce } from '../../utils/debounce';
import VectorSource from 'ol/source/Vector';

export class QueryToVectorSourceLink<T extends string> {
  private _source: VectorSource;
  private _query: Query<T>;
  private _disposer: IReactionDisposer | undefined = undefined;
  private _load: () => void;

  constructor(query: Query<T>, source: VectorSource) {
    this._source = source;
    this._query = query;

    this._load = debounce(this._source.refresh.bind(this._source), 300);
  }

  bind = () => {
    this._disposer = reaction(
      () => ({ search: this._query.search, filter: this._query.filter.value }),
      this._load,
      { fireImmediately: true },
    );

    return this.unbind;
  };

  unbind = () => {
    this._disposer?.();
    this._disposer = undefined;
  };
}
